import type { FaireProductEntity } from "../../entity_types/product";

export const p_8eb4uhzb88: FaireProductEntity = {
  token: "p_8eb4uhzb88",
  type: "product",
  name: "Teddy Pouch–Mama 2.0",
  brandToken: "b_9e5lkbzo3q",
  brandName: "The Darling Effect",
  imageUrl:
    "https://cdn.faire.com/fastly/2a17b8916bfc74bd4390dd10ee09e29f30be39934e895b13eb8e85543dead2ef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9252aef67a6ca1ae920a61ad647ee8d1729fe1c460aff06c291cd1ba19c4df1c.jpeg",
  ],
  priceDollars: 20.55,
  description:
    "Thoughtfully created to merchandise beautifully with our Made for Mama: Mother’s Day Collection\n\nBring a cozy, stylish touch to your everyday essentials with our teddy pouches. Made from soft sherpa fabric and finished with a wipeable interior lining, they blend charm with practicality for on-the-go organization. The polished gold zipper and printed inner fabric make the pouch just as delightful on the inside as it is on the outside. Mix and match with coordinating sizes for a darling, cohesive accessory set that works beautifully year-round.\n\nCozy sherpa fabric with wipeable interior lining for easy cleaning\nGold zipper and hardware\nInterior printed lining adds a special touch\nRectangle Teddy measures 10” x 3.5” x 6”\nSquare Teddy measures 6.5” x 2.5” x 6.5”\nCircle Teddy measures 4.5” diameter x 2”\n\n\n\nWARNING: Cancer and Reproductive Harm - www.P65Warnings.ca.gov",
  tags: [],
  msrpDollars: 41.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:38.786Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
